import { render, staticRenderFns } from "./ImposePopup.vue?vue&type=template&id=129c2bd2&scoped=true&"
import script from "./ImposePopup.vue?vue&type=script&lang=js&"
export * from "./ImposePopup.vue?vue&type=script&lang=js&"
import style0 from "./ImposePopup.vue?vue&type=style&index=0&id=129c2bd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129c2bd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
